export default __webpack_public_path__ + "static/media/alink.f8bd036b.svg";